// Jwt.js
import { decodeToken } from 'react-jwt';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = decodeToken(accessToken);
  if (!decoded) {
    return false;
  }

  if (decoded.exp) {
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  }

  // If no 'exp' claim, decide based on your application's needs
  // For security, it's better to require 'exp' in tokens
  return false;
};

const setSession = (accessToken) => {
  if (accessToken) {
    secureLocalStorage.setItem('authToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    secureLocalStorage.removeItem('authToken');
    delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };